import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { computeHealthCardCompletion,
  computeBasicInfoCardCompletion,
  populateUserDetailStateWithProfile,
  computeMedicalHistoryCompletion
} from "../../../../account/components/userDetailsUtilities"
import {
  initialProfileState,
  profileFieldsState,
} from "../../../../account/components/UserDetailsFormConfig"

const PercentComplete = Component => props => (
  <Component {...props} />
)

const mapStateToProps = (state, ownProps) => {
  const selectedProfile = ownProps.selectedProfile
  const {
    reproductive_health,
    general_health,
    past_surgeries,
    past_medical_conditions,
    basic_info,
  } = state.account.predispositions

  return {
    percentsComplete: {
      reproductiveHealth: reproductive_health ?
        computeHealthCardCompletion(reproductive_health.questions) : 0,
      generalHealth: general_health ?
        computeHealthCardCompletion(general_health.questions) : 0,
      medicalHistory: past_surgeries && past_medical_conditions ?
        computeMedicalHistoryCompletion([
          [...past_surgeries.questions],
          [...past_medical_conditions.questions],
        ]) : 0,
      basicInfo: basic_info && selectedProfile ?
      computeBasicInfoCardCompletion(
        populateUserDetailStateWithProfile(profileFieldsState, selectedProfile),
        basic_info.questions,
        initialProfileState,
      ) : 0,
    }
  }
}

PercentComplete.defaultProps = {
  basicInfoCompletion: 0,
  medicalHistoryCompletion: 0,
  generalHealthCompletion: 0,
  reproductiveHealthCompletion: 0,
  selectedProfile: null,
}

PercentComplete.propTypes = {
  selectedProfile: PropTypes.object.isRequired,
}

const percentCompleteWrapper = Component =>
  connect(mapStateToProps)(PercentComplete(Component))

export { percentCompleteWrapper as default }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/PercentComplete.js